import ModuleFeaturedCourse from './ModuleFeaturedCourse';

export default ModuleFeaturedCourse;
export * from './ModuleFeaturedCourse';
